export default __webpack_public_path__ + "static/media/Potassium-Mono.e9539d4d.jpg";